export enum SurveyName {
  ADMISSIONS_INTAKE = 'Intake',
  ADMISSIONS_NPS = 'Admissions NPS',
  AIMS = 'AIMS',
  ARFID = 'Weekly ED Symptom Tracker (ARFID)',
  AUDIT = 'AUDIT',
  BAS = 'Burden Assessment Scale (BAS)',
  C_SSRS_LIFETIME = 'C-SSRS - Lifetime/Recent',
  // @deprecated
  C_SSRS_LR_SCREENER = 'C-SSRS (L/R) Screen',
  // @deprecated
  C_SSRS_RECENT_SCREENER = 'C-SSRS - Recent Screen',
  C_SSRS_SINCE_LAST_CONTACT = '(C-SSRS) - Since Last Contact',
  C_SSRS_SLC_SCREENER = 'C-SSRS (SLC) Screen',
  CET = 'CET',
  DISCHARGE_SUMMARY = 'Discharge Summary',
  DUDIT = 'DUDIT',
  EARLY_RESPONSE_CHECK_IN = 'Early Response (Week 4) Check-in',
  EDE_Q = 'Eating Disorder Severity',
  FNS = 'FNS',
  GAD7 = 'GAD-7',
  LETHAL_MEANS = 'Lethal Means',
  MENTOR_MATCHING = 'Mentor Matching',
  MP_INTAKE_ASSESSMENT = 'Medical Provider Intake',
  NIAAA_BSTAD = 'NIAAA/BSTAD',
  NIAS = 'NIAS',
  NON_ARFID = 'Weekly ED Symptom Tracker',
  NPS = 'NPS',
  PARDI_ARQ_PARENT = 'ARFID Severity: Parent',
  PARDI_ARQ_SELF = 'ARFID Severity: Self',
  PATIENT_EXPERIENCE = 'Patient Experience',
  PHQ8 = 'PHQ-8',
  PHQ9 = 'PHQ-9',
  POP = 'POP Form',
  PSEA = 'PSEA',
  QUALITY_OF_LIFE = 'Quality of Life',
  SAFETY_PLAN = 'Safety Plan',
  SAMPLE_SURVEY = 'General Information',
  TREATMENT_UPDATE = 'Treatment Update',
  PCL5 = 'PCL-5',
}
